import { render } from "./ReLinkAccountsForVouchersShoutPanel.vue?vue&type=template&id=bf20d75c&scoped=true"
import script from "./ReLinkAccountsForVouchersShoutPanel.vue?vue&type=script&lang=js"
export * from "./ReLinkAccountsForVouchersShoutPanel.vue?vue&type=script&lang=js"

import "./ReLinkAccountsForVouchersShoutPanel.vue?vue&type=style&index=0&id=bf20d75c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf20d75c"]])

export default __exports__